import { useMutation } from '@apollo/client';
import { CREATE_CREATIVE_PROJECT } from '../../graphql/mutations/creativeMutations';

const sanitizeInput = (input = {}) => {
  const cleaned = { ...input };
  Object.keys(cleaned).forEach((key) => {
    const value = cleaned[key];
    if (
      value === undefined ||
      value === null ||
      (Array.isArray(value) && value.length === 0 && (key === 'images' || key === 'audios'))
    ) {
      delete cleaned[key];
    }
  });
  return cleaned;
};

export const buildCreateCreativeProjectInput = (projectData = {}) => {
  const finalInput = {
    id: projectData.id,
    creativeID: projectData.creativeID,
    title: projectData.title,
    description: projectData.description,
    status: projectData.status,
    viewCount: projectData.viewCount || 0
  };

  if (projectData.category !== undefined && projectData.category !== null && projectData.category !== '') {
    finalInput.category = projectData.category;
  }

  if (
    projectData.tags !== undefined &&
    projectData.tags !== null &&
    Array.isArray(projectData.tags) &&
    projectData.tags.length > 0
  ) {
    finalInput.tags = projectData.tags;
  }

  if (projectData.studioID !== undefined && projectData.studioID !== null && projectData.studioID !== '') {
    finalInput.studioID = projectData.studioID;
  }

  if (projectData.images && Array.isArray(projectData.images) && projectData.images.length > 0) {
    finalInput.images = projectData.images;
  }

  if (projectData.audios && Array.isArray(projectData.audios) && projectData.audios.length > 0) {
    finalInput.audios = projectData.audios;
  }

  return sanitizeInput(finalInput);
};

/**
 * Hook to create a new Creative Project
 * @returns {object} - { handleCreateProject, loading, error }
 */
export const useCreateCreativeProject = () => {
  const [createProjectMutation, { loading, error }] = useMutation(CREATE_CREATIVE_PROJECT, {
    refetchQueries: ['CreativeProjectsByCreativeID', 'GetCreative'],
    awaitRefetchQueries: true
  });

  const handleCreateProject = async (projectData) => {
    try {
      if (!projectData?.creativeID) {
        throw new Error('Das Creative-Profil konnte nicht zugeordnet werden. Bitte lade die Seite neu und versuche es erneut.');
      }

      if (!projectData?.title) {
        throw new Error('Bitte gib einen Projekttitel ein.');
      }

      if (!projectData?.status) {
        throw new Error('Der Projektstatus konnte nicht gesetzt werden. Bitte versuche es erneut.');
      }

      const finalInput = buildCreateCreativeProjectInput(projectData);

      const variables = { input: finalInput };

      const { data: projectResponse } = await createProjectMutation({
        variables
      });
      
      return projectResponse?.createCreativeProject;
    } catch (error) {
      console.error('Error creating creative project:', error);
      throw error;
    }
  };

  return {
    handleCreateProject,
    loading,
    error
  };
};
